import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import React from 'react';
import { SyncList } from './SyncList';
import { SyncNowButton } from './SyncNowButton';

import { Import, importsActions } from '@sonar-software/sonar-imports';
import { SonarCard, ViewArea } from '@ui/general';
import { useAction, useCurrentUser, useInterval, useOnMount, useSonarSelector } from '@hooks';

export const latestImportSelectors = createAsyncSelectors((state) => state.imports.latest.get);

export const SyncView: React.FC = () => {
	const { isReadOnly } = useCurrentUser();
	const latestSyncs = useSonarSelector(latestImportSelectors.data);

	const getLatestSyncs = useAction(importsActions.requestGetImportsLatest);

	useOnMount(() => {
		getLatestSyncs({ count: 20 });
	});

	useInterval(() => {
		getLatestSyncs({ count: 20 });
	}, 10000);

	return (
		<ViewArea
			direction='horizontal'
			fullHeight
			fullWidth
			id='syncs-view'>
			<SonarCard
				extra={ !isReadOnly && <SyncNowButton /> }
				noSpacing
				title={ COPY_SPECIFIC.METADATA_IMPORT_LOGS }>
				<SyncList syncs={ (latestSyncs ?? []) as Import[] } />
			</SonarCard>
		</ViewArea>
	);
};
